module.exports = __webpack_public_path__ + "img/prototypes_overview.1ec4b57d.jpg";